module.exports = __webpack_public_path__ + "03_short_brown.88d65a1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_short_brown.png
// module id = Wxp3
// module chunks = 0